var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.signInShow
    ? _c(
        "div",
        { staticClass: "popup" },
        [
          _vm.state == "signIn" ||
          _vm.state == "signUp" ||
          _vm.state == "forgetPwd"
            ? _c(
                "div",
                {
                  staticClass: "content login-popup",
                  class: _vm.getPopupClass(),
                  attrs: {
                    id: "signInPopup",
                    "element-loading-background": "rgba(0, 0, 0, 0.1)"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "title",
                      staticStyle: {
                        background: "white",
                        height: "30px",
                        "border-radius": "10px"
                      }
                    },
                    [
                      _vm.state == "forgetPwd"
                        ? _c(
                            "div",
                            {
                              staticClass: "title-back",
                              on: {
                                click: function($event) {
                                  return _vm.backSignIn()
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "icon-util arrow-left-blue"
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "alink" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("language.cloudExploer.back"))
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "icon-popup-close",
                        on: { click: _vm.closeDialog }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.forgotPasswordShow
                    ? _c("div", [
                        _c("div", { staticClass: "popup-body" }, [
                          _c("div", { staticClass: "page-body" }, [
                            _vm.state == "signIn"
                              ? _c("div", [
                                  _c("div", { staticClass: "logo" }),
                                  _vm._v(" "),
                                  !_vm.isTransfer
                                    ? _c("h2", { staticClass: "sign-title" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("language.login.title"))
                                        )
                                      ])
                                    : _c("h2", { staticClass: "sign-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.shareTransfers.signTitleByTransfer"
                                            )
                                          )
                                        )
                                      ]),
                                  _vm._v(" "),
                                  _c("hr", { staticClass: "sign-top-line" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "font14",
                                      staticStyle: { "margin-bottom": "17px" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.login.tips2")) +
                                          "\n                                "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "ga",
                                              rawName: "v-ga",
                                              value: {
                                                eventAction: "click",
                                                eventCategory: "/sign.html",
                                                eventLabel: "/share-pop"
                                              },
                                              expression:
                                                "{eventAction:'click',eventCategory:'/sign.html',eventLabel:'/share-pop'}"
                                            }
                                          ],
                                          staticClass: "alink",
                                          on: {
                                            click: function($event) {
                                              return _vm.toSignUp()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("language.login.signUp")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mc-row" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "ic-label ic-email",
                                        class: _vm.inputClass(
                                          _vm.selectInput.email
                                        ),
                                        attrs: { for: "" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.email,
                                              expression: "email"
                                            }
                                          ],
                                          staticClass: "width100",
                                          class: _vm.inputClass(
                                            _vm.selectInput.email
                                          ),
                                          attrs: {
                                            type: "text",
                                            name: "email",
                                            placeholder: _vm.$t(
                                              "language.login.logEmailInput"
                                            ),
                                            autoComplete: "off"
                                          },
                                          domProps: { value: _vm.email },
                                          on: {
                                            focus: function($event) {
                                              return _vm.focusInput("email")
                                            },
                                            blur: function($event) {
                                              return _vm.testEmail()
                                            },
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.email = $event.target.value
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "tips-info",
                                        class: _vm.tipsClass(
                                          _vm.selectInput.email
                                        )
                                      },
                                      [_vm._v(_vm._s(_vm.tipsMsg.email))]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mc-row" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "ic-label ic-password",
                                        class: _vm.inputClass(
                                          _vm.selectInput.password
                                        ),
                                        attrs: { for: "" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.password,
                                              expression: "password"
                                            }
                                          ],
                                          ref: "passwordLogin",
                                          staticClass: "width100",
                                          class: _vm.inputClass(
                                            _vm.selectInput.password
                                          ),
                                          attrs: {
                                            type: "password",
                                            name: "password",
                                            autocomplete: "new-password",
                                            placeholder: _vm.$t(
                                              "language.login.password"
                                            )
                                          },
                                          domProps: { value: _vm.password },
                                          on: {
                                            focus: function($event) {
                                              return _vm.focusInput("password")
                                            },
                                            blur: function($event) {
                                              return _vm.testPassword()
                                            },
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.password = $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "password-eye",
                                          class: _vm.showPassword
                                            ? "icon-eye"
                                            : "icon-eye-hide",
                                          on: {
                                            click: function($event) {
                                              return _vm.checkShowPassword()
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "tips-info",
                                        class: _vm.tipsClass(
                                          _vm.selectInput.password
                                        )
                                      },
                                      [_vm._v(_vm._s(_vm.tipsMsg.password))]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.forget
                                    ? _c("div", { staticClass: "mc-row" }, [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "ic-label ic-verification f-dib width68",
                                            class: _vm.inputClass(
                                              _vm.selectInput.code
                                            ),
                                            attrs: { for: "" }
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.code,
                                                  expression: "code"
                                                }
                                              ],
                                              staticClass: "width100",
                                              class: _vm.inputClass(
                                                _vm.selectInput.code
                                              ),
                                              attrs: {
                                                type: "text",
                                                name: "verificationCode",
                                                placeholder: _vm.$t(
                                                  "language.login.verificationCode"
                                                ),
                                                id: "signUpCode"
                                              },
                                              domProps: { value: _vm.code },
                                              on: {
                                                focus: function($event) {
                                                  return _vm.focusInput("code")
                                                },
                                                blur: function($event) {
                                                  return _vm.testCode()
                                                },
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.code = $event.target.value
                                                }
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "f-dib" }, [
                                          _c("img", {
                                            staticClass:
                                              "sign-verificationCode",
                                            attrs: { src: _vm.ficationCode },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.refreshAndClearCode()
                                              }
                                            }
                                          })
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "err tips-info",
                                            class: _vm.tipsClass(
                                              _vm.selectInput.code
                                            )
                                          },
                                          [_vm._v(_vm._s(_vm.tipsMsg.code))]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mc-row remember-forget-pass",
                                      staticStyle: {
                                        "margin-bottom": "20px",
                                        "padding-top": "10px"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "remember-check",
                                          on: {
                                            click: function($event) {
                                              return _vm.clickRemenberPass()
                                            }
                                          }
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "icon-check",
                                            class: _vm.remenberPass
                                              ? ""
                                              : "icon-check-none"
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "remember-me" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("language.login.keepLogin")
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "alink",
                                          staticStyle: {
                                            float: "right",
                                            color: "#282CB1"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.goToForgotPwd()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.login.forgotPassword"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "mc-row btn",
                                      staticStyle: { "margin-bottom": "20px" }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "err tips-info",
                                          class: _vm.tipsClass(
                                            _vm.selectInput.btn
                                          ),
                                          staticStyle: {
                                            position: "absolute",
                                            top: "-21px"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.tipsMsg.btn))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "login-btn",
                                          class: _vm.loading ? "no-click" : "",
                                          on: {
                                            click: function($event) {
                                              return _vm.login()
                                            }
                                          }
                                        },
                                        [
                                          _vm.loading
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.login.btnTxt"
                                                    )
                                                  )
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.login.logInButton"
                                                    )
                                                  )
                                                )
                                              ])
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "login-thirdLogin" },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "thirdLogin-tip" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "language.login.continueWith"
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "thirdLogin" }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "thirdLogin-btn",
                                            staticStyle: { float: "left" },
                                            on: {
                                              click: function($event) {
                                                return _vm.thirdLogin(
                                                  "google_drive"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "sign-third-logo sign-google"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "thirdLogin-btn",
                                            on: {
                                              click: function($event) {
                                                return _vm.thirdLogin("apple")
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "sign-third-logo sign-apple"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "thirdLogin-btn",
                                            staticStyle: { float: "right" },
                                            on: {
                                              click: function($event) {
                                                return _vm.thirdLogin(
                                                  "facebook"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "sign-third-logo sign-facebook"
                                            })
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm.state == "signUp"
                            ? _c(
                                "div",
                                { staticClass: "page-body" },
                                [
                                  _c("signUpDialog", {
                                    ref: "signUpDialog",
                                    attrs: { isTransfer: _vm.isTransfer }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.state == "forgetPwd"
                            ? _c(
                                "div",
                                { staticClass: "page-body" },
                                [
                                  _c("forgetPwdDialog", {
                                    ref: "forgetPwdDialog"
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("messages", { ref: "messages" }),
          _vm._v(" "),
          _vm.state != "signIn" &&
          _vm.state != "signUp" &&
          _vm.state != "forgetPwd"
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticClass: "content",
                  style:
                    _vm.state == "recovery-success" ? "height: 480px;" : "",
                  attrs: {
                    id: "verify",
                    "element-loading-background": "rgba(0, 0, 0, 0.1)"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "title",
                      staticStyle: { background: "white", height: "30px" }
                    },
                    [
                      _c("div", {
                        staticClass: "icon black-close dialog-close",
                        on: {
                          click: function($event) {
                            return _vm.closeDialog()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.state == "verify"
                    ? _c("div", [
                        _c("div", { staticClass: "verify-title" }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.popup.verifyPopup.verifyTitle")
                              ) + "\n                        "
                            ),
                            _c("div", {
                              staticClass: "ic-back",
                              on: {
                                click: function($event) {
                                  _vm.state = _vm.recoveryPending
                                    ? "recovery-pending"
                                    : _vm.backState
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "verify-body" }, [
                          _c("div", { staticClass: "verify-choice-body" }, [
                            _vm.vEmail
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "login-btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.choiceVerifyMethod("email")
                                      }
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "verify-email",
                                      staticStyle: { position: "inherit" }
                                    }),
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("language.login.email") +
                                          "  " +
                                          _vm.vEmail
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.vPhone
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "login-btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.choiceVerifyMethod("phone")
                                      }
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "verify-phone",
                                      staticStyle: { position: "inherit" }
                                    }),
                                    _vm._v(_vm._s("Text  " + _vm.vPhone))
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "text-align": "center" } },
                            [
                              _c(
                                "a",
                                {
                                  staticStyle: { "text-decoration": "inherit" },
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function($event) {
                                      _vm.state = _vm.recoveryPending
                                        ? "recovery-cancel-error"
                                        : "verify-recovery"
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "language.popup.verifyPopup.toRecoveryText"
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state == "verify-email" || _vm.state == "verify-phone"
                    ? _c("div", [
                        _c("div", { staticClass: "verify-title" }, [
                          _vm.choiceVerify == "email"
                            ? _c("h2", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.verifyPopup.verifyEmailTitle"
                                    )
                                  ) + "\n                        "
                                ),
                                _c("div", {
                                  staticClass: "ic-back",
                                  on: {
                                    click: function($event) {
                                      _vm.state = "verify"
                                    }
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.choiceVerify == "phone"
                            ? _c("h2", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.verifyPopup.verifyPhoneTitle"
                                    )
                                  ) + "\n                        "
                                ),
                                _c("div", {
                                  staticClass: "ic-back",
                                  on: {
                                    click: function($event) {
                                      _vm.state = "verify"
                                    }
                                  }
                                })
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "verify-body" }, [
                          _vm.choiceVerify == "email"
                            ? _c("div", [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "language.popup.verifyPopup.verifyEmailTips",
                                        { email: _vm.vEmail }
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "sign-line" }, [
                                  _c("div", { staticClass: "sign-input" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.verifyEmail,
                                          expression: "verifyEmail"
                                        }
                                      ],
                                      staticClass: "signInInfo",
                                      attrs: {
                                        type: "text",
                                        name: "verifyEmail",
                                        placeholder: "someone@example.com"
                                      },
                                      domProps: { value: _vm.verifyEmail },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.verifyEmail = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "verify-email-grow"
                                    })
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "sene-code-btn login-btn",
                                    class: _vm.loading ? "btn-not-allowed" : "",
                                    on: {
                                      click: function($event) {
                                        return _vm.sendVerifyCodeByEmail()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.verifyPopup.sendCodeBtn"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.choiceVerify == "phone"
                            ? _c("div", [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "language.popup.verifyPopup.verifyPhoneTips",
                                        {
                                          phone: _vm.vPhone,
                                          last: _vm.vPhone.substring(
                                            _vm.vPhone.length - 2,
                                            _vm.vPhone.length
                                          )
                                        }
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "sign-line" }, [
                                  _c("div", { staticClass: "sign-input" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.verifyPhone,
                                          expression: "verifyPhone"
                                        }
                                      ],
                                      staticClass: "signInInfo",
                                      attrs: {
                                        type: "text",
                                        name: "verifyPhone",
                                        placeholder: _vm.$t(
                                          "language.popup.verifyPopup.verifyPhoneText"
                                        ),
                                        maxlength: "4"
                                      },
                                      domProps: { value: _vm.verifyPhone },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.verifyPhone = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "verify-phone-grow"
                                    })
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "sene-code-btn login-btn",
                                    class: _vm.loading ? "btn-not-allowed" : "",
                                    on: {
                                      click: function($event) {
                                        return _vm.sendVerifyCodeByPhone()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.verifyPopup.sendCodeBtn"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state == "verify-code"
                    ? _c("div", [
                        _c("div", { staticClass: "verify-title" }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.verifyPopup.verifyEmailTitle"
                                )
                              ) + "\n                        "
                            ),
                            _c("div", {
                              staticClass: "ic-back",
                              on: {
                                click: function($event) {
                                  _vm.state = "verify-" + _vm.choiceVerify
                                  _vm.verifyCode = ""
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "verify-body" }, [
                          _vm.choiceVerify == "email"
                            ? _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.verifyPopup.checkEmailTips",
                                      { email: _vm.vEmail }
                                    )
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.choiceVerify == "phone"
                            ? _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.verifyPopup.checkPhoneTips",
                                      {
                                        phone: _vm.vtPhone.substring(
                                          _vm.vtPhone.length - 4,
                                          _vm.vtPhone.length
                                        )
                                      }
                                    )
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "sign-line" }, [
                            _c("div", { staticClass: "sign-input" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.verifyCode,
                                    expression: "verifyCode"
                                  }
                                ],
                                staticClass: "signInInfo",
                                staticStyle: { "text-indent": "0px" },
                                attrs: {
                                  type: "text",
                                  name: "verifyCode",
                                  placeholder: _vm.$t(
                                    "language.login.verificationCode"
                                  ),
                                  maxlength: "6"
                                },
                                domProps: { value: _vm.verifyCode },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.verifyCode = $event.target.value
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "ask-device" }, [
                            !_vm.recoveryPending
                              ? _c("div", {
                                  staticClass: "icon-util",
                                  class: _vm.askDevice
                                    ? "check-small"
                                    : "nocheck-small",
                                  on: {
                                    click: function($event) {
                                      return _vm.clickAskDevice()
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.recoveryPending
                              ? _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "language.popup.verifyPopup.askDevice"
                                      )
                                    )
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                class: _vm.loading ? "btn-not-allowed" : "",
                                attrs: { ckass: "login-btn" },
                                on: {
                                  click: function($event) {
                                    return _vm.verificationCode()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.verifyPopup.verify")
                                  )
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state == "verify-recovery"
                    ? _c("div", [
                        _c("div", { staticClass: "verify-title" }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.verifyPopup.recoveryTitile"
                                )
                              ) + "\n                        "
                            ),
                            _c("div", {
                              staticClass: "ic-back",
                              on: {
                                click: function($event) {
                                  _vm.state = "verify"
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "verify-body" }, [
                          _c("p", { staticStyle: { "margin-top": "5%" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.verifyPopup.recoveryTipsOne"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticStyle: { "margin-top": "5%" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.verifyPopup.recoveryTipsTwo"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "sign-line" }, [
                            _c("div", { staticClass: "sign-input" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.verifyRecoveryCode,
                                    expression: "verifyRecoveryCode"
                                  }
                                ],
                                staticClass: "signInInfo",
                                staticStyle: { "text-indent": "0px" },
                                attrs: {
                                  type: "text",
                                  name: "verifyRecoveryCode",
                                  placeholder: _vm.$t(
                                    "language.popup.verifyPopup.recoveryCode"
                                  )
                                },
                                domProps: { value: _vm.verifyRecoveryCode },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.verifyRecoveryCode = $event.target.value
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "sene-code-btn login-btn",
                              class: _vm.loading ? "btn-not-allowed" : "",
                              on: {
                                click: function($event) {
                                  return _vm.verificationRecoveryCode()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.verifyPopup.recoveryCodeBtn"
                                  )
                                )
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state == "recovery-change"
                    ? _c("div", [
                        _c("div", { staticClass: "verify-title" }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.verifyPopup.recoveryChangeTitile"
                                )
                              ) + "\n                        "
                            ),
                            _c("div", {
                              staticClass: "ic-back",
                              on: {
                                click: function($event) {
                                  _vm.state = "verify-recovery"
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "verify-body",
                            staticStyle: { "margin-top": "70px" }
                          },
                          [
                            _c("cloud-select", {
                              ref: "cloudSelect",
                              staticStyle: {
                                margin: "0 !important",
                                float: "left"
                              },
                              attrs: {
                                widthVal: 300,
                                selectOption: _vm.selectOption,
                                placeholder: _vm.selectValue
                              },
                              on: {
                                changeOption: function($event) {
                                  return _vm.onChangeOption()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.choiceVerify == "phone"
                              ? _c("cloud-select", {
                                  ref: "phoneSelect",
                                  staticStyle: {
                                    margin: "0 !important",
                                    float: "left"
                                  },
                                  attrs: {
                                    widthVal: 300,
                                    selectOption: _vm.selectPhoneOption,
                                    placeholder: _vm.selectPhoneValue
                                  },
                                  on: {
                                    deleteSelectOption: function($event) {
                                      return _vm.showOtherOptions()
                                    },
                                    changeOption: function($event) {
                                      return _vm.onChangePhoneOption()
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.choiceVerify == "email"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.verifyEmail,
                                      expression: "verifyEmail"
                                    }
                                  ],
                                  staticClass: "ftp-cont-right-one",
                                  staticStyle: {
                                    width: "100%",
                                    marginBottom: "10Px"
                                  },
                                  attrs: {
                                    type: "text",
                                    placeholder: _vm.$t(
                                      "language.popup.verifyPopup.enterEmail"
                                    )
                                  },
                                  domProps: { value: _vm.verifyEmail },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.verifyEmail = $event.target.value
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.choiceVerify == "phone"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.verifyPhone,
                                      expression: "verifyPhone"
                                    }
                                  ],
                                  staticClass: "ftp-cont-right-one",
                                  staticStyle: {
                                    width: "100%",
                                    marginBottom: "10Px"
                                  },
                                  attrs: {
                                    type: "text",
                                    placeholder: _vm.$t(
                                      "language.popup.verifyPopup.codeText"
                                    )
                                  },
                                  domProps: { value: _vm.verifyPhone },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.verifyPhone = $event.target.value
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "sene-code-btn login-btn",
                                class: _vm.loading ? "btn-not-allowed" : "",
                                on: {
                                  click: function($event) {
                                    return _vm.sendVerifyByRecovery()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.reportPopup.next")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state == "recovery-verify-code"
                    ? _c("div", [
                        _c("div", { staticClass: "verify-title" }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.verifyPopup.recoveryNextTitle",
                                  {
                                    checkCode:
                                      _vm.choiceVerify == "email"
                                        ? _vm.verifyEmail
                                        : _vm.verifyPhone
                                  }
                                )
                              ) + "\n                        "
                            ),
                            _c("div", {
                              staticClass: "ic-back",
                              on: {
                                click: function($event) {
                                  _vm.state = "recovery-change"
                                  _vm.verifyCode = ""
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "verify-body",
                            staticStyle: { "margin-top": "70px" }
                          },
                          [
                            _c("div", { staticClass: "sign-line" }, [
                              _c("div", { staticClass: "sign-input" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.verifyCode,
                                      expression: "verifyCode"
                                    }
                                  ],
                                  staticClass: "signInInfo",
                                  staticStyle: { "text-indent": "0px" },
                                  attrs: {
                                    type: "text",
                                    name: "verifyCode",
                                    placeholder: _vm.$t(
                                      "language.login.verificationCode"
                                    ),
                                    maxlength: "6"
                                  },
                                  domProps: { value: _vm.verifyCode },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.verifyCode = $event.target.value
                                    }
                                  }
                                })
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "sene-code-btn login-btn",
                                class: _vm.loading ? "btn-not-allowed" : "",
                                on: {
                                  click: function($event) {
                                    return _vm.verificationCode()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.reportPopup.next")
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state == "recovery-success"
                    ? _c("div", [
                        _c("div", { staticClass: "verify-title" }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.verifyPopup.recoveryTipsTitle"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "verify-body recovery-success" },
                          [
                            _c("p", { staticStyle: { color: "#D6D6D6" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.verifyPopup.recoveryTips1"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticStyle: { color: "#D6D6D6" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.verifyPopup.recoveryTips2"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticStyle: { "margin-top": "5%" } }, [
                              _c(
                                "p",
                                { staticStyle: { "font-weight": "700" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "language.popup.verifyPopup.recoveryTips3"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "700" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.verifyPopup.recoveryTips4"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.verifyPopup.recoveryTips5"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "700" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.verifyPopup.recoveryTips6"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.verifyPopup.recoveryTips7"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.verifyPopup.recoveryTips8"
                                    )
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "sene-code-btn login-btn",
                                staticStyle: { "margin-top": "15px" },
                                on: {
                                  click: function($event) {
                                    _vm.state = "signIn"
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.reportPopup.next")
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state == "recovery-pending"
                    ? _c("div", [
                        _c("div", { staticClass: "verify-title" }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.verifyPopup.recoveryPendTitle"
                                )
                              ) + "\n                        "
                            ),
                            _c("div", {
                              staticClass: "ic-back",
                              on: {
                                click: function($event) {
                                  _vm.state = _vm.backState
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "verify-body recovery-success" },
                          [
                            _c("p", { staticStyle: { color: "#D6D6D6" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.verifyPopup.recoveryPendTips1",
                                    { data: _vm.pendData }
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticStyle: { "margin-top": "5%" } }, [
                              _c(
                                "p",
                                { staticStyle: { "font-weight": "700" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "language.popup.verifyPopup.recoveryPendTips2"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.vEmail
                                ? _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.verifyPopup.recoveryPendTips3"
                                        ) + _vm.vEmail
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.vPhone
                                ? _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.verifyPopup.recoveryPendTips4"
                                        ) + _vm.vPhone
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "5%" } },
                                [
                                  _c(
                                    "p",
                                    { staticStyle: { "font-weight": "700" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.verifyPopup.recoveryPendTips5"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.pendEmail
                                    ? _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.popup.verifyPopup.recoveryPendTips3"
                                            ) + _vm.pendEmail
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.pendPhone
                                    ? _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.popup.verifyPopup.recoveryPendTips4"
                                            ) + _vm.pendPhone
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "5%" } },
                                [
                                  _c("p", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.verifyPopup.recoveryPendTips6"
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                    _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          "text-decoration": "inherit"
                                        },
                                        attrs: { href: "javascript:void(0);" },
                                        on: {
                                          click: function($event) {
                                            return _vm.cancelVerify()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.popup.verifyPopup.recoveryPendTips7"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state == "recovery-cancel"
                    ? _c("div", [
                        _c("div", { staticClass: "verify-title" }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.verifyPopup.recoveryCancelTitle"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "verify-body recovery-success" },
                          [
                            _c("p", { staticStyle: { color: "#D6D6D6" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.verifyPopup.recoveryCancelTips1"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticStyle: { color: "#D6D6D6" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.verifyPopup.recoveryCancelTips2"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticStyle: { color: "#D6D6D6" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.verifyPopup.recoveryCancelTips3"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticStyle: { "margin-top": "5%" } }, [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.verifyPopup.recoveryCancelTips4"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticStyle: { "font-weight": "700" } },
                                [_vm._v(_vm._s(_vm.newRecoveryCode))]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "sene-code-btn login-btn",
                                staticStyle: { "margin-top": "15px" },
                                on: {
                                  click: function($event) {
                                    _vm.state = "recovery-cancel-success"
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.reportPopup.next")
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state == "recovery-cancel-success"
                    ? _c("div", [
                        _c("div", { staticClass: "verify-title" }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.verifyPopup.recoveryCancelSucTitle"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "verify-body recovery-success" },
                          [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.verifyPopup.recoveryCancelSucTips1",
                                    { old: _vm.email }
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.verifyPopup.recoveryCancelSucTips2",
                                    { new: _vm.dual.pendingVerifyDevice }
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticStyle: { "margin-top": "5%" } }, [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.verifyPopup.recoveryCancelSucTips3"
                                    )
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "sene-code-btn login-btn",
                                staticStyle: { "margin-top": "15px" },
                                on: {
                                  click: function($event) {
                                    _vm.state = "signIn"
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.reportPopup.next")
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state == "recovery-cancel-error"
                    ? _c("div", [
                        _c("div", { staticClass: "verify-title" }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.verifyPopup.recoveryCancelErrorTitle"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "verify-body recovery-success" },
                          [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  color: "red",
                                  "margin-bottom": "25%"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.verifyPopup.recoveryCancelErrorTips"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "sene-code-btn",
                                staticStyle: { "margin-top": "15px" },
                                on: {
                                  click: function($event) {
                                    _vm.state = "verify"
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.reportPopup.next")
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35240419", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35240419","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/share_page_popups/sign_in_popup.vue
// module id = null
// module chunks = 